<script lang="ts">
	import { PUBLIC_TOLSTOY_APP_KEY } from '$env/static/public';
	import type { ISbStoryData } from '@storyblok/js';
	import { onMount } from 'svelte';

	interface Props {
		content: ISbStoryData<{
			publish_id: string;
		}>['content'];
	}

	let { content }: Props = $props();

	onMount(() => {
		window.tolstoyAppKey = PUBLIC_TOLSTOY_APP_KEY;
		window.tolstoyWidgetId = content.publish_id;
		var s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = 'https://widget.gotolstoy.com/widget/widget.js';
		document.head.appendChild(s);
	});
</script>

<style>
	:global(#tolstoyWidgetElement) {
		z-index: 20 !important;
	}
</style>
